import React, {useContext} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import JSONDataContext from "../../context";
import {
	intern_toggle_modal_origin_destination_open
} from '../../actions'
import {ReactComponent as XClose} from '../../assets/svg/x_close.svg'


const InternModusOriginDestOverlay = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch()
    
    const context = useContext(JSONDataContext)
	
	const modal_origin_destination_open = useSelector(state => state.general.intern_ui.modal_origin_destination_open);
	const origin_station_code = useSelector(state => state.general.intern_config.origin_station_code);

	const step_origin_value = origin_station_code ? context.general.all_stations?.find(x => x.code === origin_station_code)?.label ?? t('Unbekannter Bahnhof') : ''

    const close_clicked = (e) => {
        e.preventDefault()
        dispatch(intern_toggle_modal_origin_destination_open(false))
    }

    const modal_text = () => {
        if(origin_station_code){
            return <span className="text"><strong>{step_origin_value}</strong> → {t('Klick Zielbahnhof')}</span>;

        }
        return <>
            <span className="text">{t('Klick Startbahnhof')}</span>
        </>
    }

    const modal_class = () => {
        return modal_origin_destination_open ? 'mini-dialog-overlay show' : 'mini-dialog-overlay';
    }

    return (
        <>
            <div className={modal_class()} tabIndex="-1" aria-modal="true" role="dialog">
                <div className="mini-dialog-overlay-content">
                    {modal_text()}
                </div>
                <div className="mini-dialog-overlay-close-handler">
                    <button className="close-handler" onClick={close_clicked}>
                        <span className="visuallyhidden">{t("Start/Ziel schliessen")}</span>
                        <div className="close-icon">
                            <div className="circle"></div>
                            <XClose />
                        </div>
                    </button>
                </div>
            </div>
        </>
    )

}

export default InternModusOriginDestOverlay